// extracted by mini-css-extract-plugin
export var header = "_uz-1";
export var maskBottom = "_uz-6";
export var maskMiddle = "_uz-7";
export var maskTop = "_uz-5";
export var root = "_uz-0";
export var scrollDownButton = "_uz-3";
export var scrollDownButtonHidden = "_uz-4";
export var viewport = "_uz-2";